module.exports = __webpack_public_path__ + "static/img/glove_perrier.5300545.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colors/women/glove_perrier.png
// module id = 6DOg
// module chunks = 0